import ApiService from '@/services/core/api.service'

const HistoryService = {
  async get (query = '') {
    return ApiService.get(`user/reports/payment-approvals?${query}`)
  },

  async post (payload) {
    return ApiService.post('user/reports/payment-approvals', payload)
  },

  async put (payload) {
    return ApiService.put(`user/reports/payment-approvals/${payload.id}`, payload)
  },

  async delete (payload) {
    return ApiService.delete(`user/reports/payment-approvals/${payload.id}`)
  }
}

export default HistoryService
